export const isSuperAdmin = (email: string): boolean => {
  if (!email) return false;
  
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) return false;
  
  // SUPER-ADMIN domains
  const superAdminDomains = [
    'campaignking.ai',
    'sharadtech.com', 
    'scenicmediahub.com'
  ];
  
  return superAdminDomains.includes(domain);
}; 